import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-werknemer-componenten',
  standalone: true,
  imports: [CommonModule, SharedUiButtonModule],
  templateUrl: './tekst-werknemer-componenten.component.html',
  styleUrl: './tekst-werknemer-componenten.component.scss',
})
export class TekstWerknemerComponentenComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  @Input() public id!: string;
  public ibAangifte = {} as Aangifte;
  public focusedElementId: string | null = null;
  public year = 2024;
  public actualYear: number = new Date().getFullYear();


  constructor(
      public dataService: BokkzIbDataService) {
  }

  ngOnInit(): void {
    this.dataService.incomeTaxEntity
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
      if (value.year !== undefined) {
        this.year = value.year;
      }
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  helpTextMap: Record<string, { title: string; content: string }> = {
    personeelsnummer: {
      title: 'Personeelsnummer',
      content: 'Het personeelsnummer is een uniek kenmerk binnen de salaris- en personeelsadministratie. Het wordt gebruikt voor koppelingen, rapportages en identificatie.'
    },
    // voeg hier andere topics toe
  };

}

